'use client';

import {motion} from 'framer-motion';
import useTopStyle from 'utils/useTopStyle';
import BookBtn from '../buttons/BookBtn/BookBtn';
import heroVariants from 'animation/heroVariants';
import spanVariants from 'animation/spanVariants';
import OperationsHeroSvg from 'animation/svg-anim/OperationsHeroSvg';

const OperationsHero = () => {
  const ref = useTopStyle(72);

  return (
    <motion.section
      className='operations-hero'
      ref={ref}
      initial={'hidden'}
      animate={'visible'}
      transition={{
        duration: 0.7,
        delay: 0.5,
        ease: 'easeInOut'
      }}
      variants={heroVariants}
    >
      <div className='container'>
        <div className='bg-line'>
          <OperationsHeroSvg />
        </div>
        <div className='content'>
          <h2 className='title'>
            Universal management, streamlined
            <motion.span
              className='highlight'
              initial={'hidden'}
              animate={'visible'}
              transition={{
                duration: 0.8,
                delay: 0.8,
                ease: 'easeInOut'
              }}
              variants={spanVariants}
            >
              operations
            </motion.span>
          </h2>
          <p className='text'>Scale your administrative objectives and meet compliance needs in a single pane of glass.</p>
          <BookBtn/>
        </div>
        <div className='design'></div>
      </div>
    </motion.section>
  );
};

export default OperationsHero;

